export default __webpack_public_path__ + "static/media/galin_m.13a5a501.jpg";